/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-marker.reducer';

export const PatientMarkerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientMarkerEntity = useAppSelector(state => state.patientMarker.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientMarkerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientMarker.detail.title">PatientMarker</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientMarker.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.id}</dd>
          <dt>
            <span id="potentialFor">
              <Translate contentKey="tinyMedicRestApp.patientMarker.potentialFor">Potential For</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.potentialFor}</dd>
          <dt>
            <span id="procedureType">
              <Translate contentKey="tinyMedicRestApp.patientMarker.procedureType">Procedure Type</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.procedureType}</dd>
          <dt>
            <span id="modeOfPayment">
              <Translate contentKey="tinyMedicRestApp.patientMarker.modeOfPayment">Mode Of Payment</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.modeOfPayment}</dd>
          <dt>
            <span id="remarks">
              <Translate contentKey="tinyMedicRestApp.patientMarker.remarks">Remarks</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.remarks}</dd>
          <dt>
            <span id="academicInterest">
              <Translate contentKey="tinyMedicRestApp.patientMarker.academicInterest">Academic Interest</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.academicInterest ? 'true' : 'false'}</dd>
          <dt>
            <span id="complete">
              <Translate contentKey="tinyMedicRestApp.patientMarker.complete">Complete</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.complete ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientMarker.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientMarker.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientMarker.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientMarker.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientMarker.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientMarkerEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientMarker.appointment">Appointment</Translate>
          </dt>
          <dd>{patientMarkerEntity.appointment ? patientMarkerEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientMarker.doctor">Doctor</Translate>
          </dt>
          <dd>{patientMarkerEntity.doctor ? patientMarkerEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientMarker.patient">Patient</Translate>
          </dt>
          <dd>{patientMarkerEntity.patient ? patientMarkerEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-marker" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-marker/${patientMarkerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientMarkerDetail;
